import React from 'react';
import type { IconProps } from './types';

// Lighter-weight pencil glyph used on note cards.
const PencilNoteIcon: React.FC<IconProps> = ({ size = 14, color = 'currentColor', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3Z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

export default PencilNoteIcon;
